module.exports = __webpack_public_path__ + "75e5868a6b927d223a430b1caf4521a9.png";